import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/interfaces/pcg-table-column.interface';

export class KnowledgeBaseSectionVm {
	sectionId: number;
	header?: string;
	content?: string;
	videoId?: string;
	sortOrder: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'sectionId': new UntypedFormControl(0, [...(validators['sectionId'] ?? []), ...[Validators.required]]),
			'header': new UntypedFormControl(null, [...(validators['header'] ?? []), ...[Validators.maxLength(100)]]),
			'content': new UntypedFormControl(null, [...(validators['content'] ?? []), ...[]]),
			'videoId': new UntypedFormControl(null, [...(validators['videoId'] ?? []), ...[]]),
			'sortOrder': new UntypedFormControl(0, [...(validators['sortOrder'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): KnowledgeBaseSectionVmFromFg {
		return new KnowledgeBaseSectionVmFromFg(fg);
	}
}

export class KnowledgeBaseSectionVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get sectionId(): number {
		return this.fg.get('sectionId').value;
	}
	set sectionId(val) {
		this.fg.get('sectionId').setValue(val);
	}

	get header(): string {
		return this.fg.get('header').value;
	}
	set header(val) {
		this.fg.get('header').setValue(val);
	}

	get content(): string {
		return this.fg.get('content').value;
	}
	set content(val) {
		this.fg.get('content').setValue(val);
	}

	get videoId(): string {
		return this.fg.get('videoId').value;
	}
	set videoId(val) {
		this.fg.get('videoId').setValue(val);
	}

	get sortOrder(): number {
		return this.fg.get('sortOrder').value;
	}
	set sortOrder(val) {
		this.fg.get('sortOrder').setValue(val);
	}
}
